import React from 'react';

import { RouteLayout } from 'shared/components/layouts';

import { EventsContent } from '../components';

export const EventsPage: React.FC = () => {
  return <RouteLayout content={<EventsContent />} withFullWidth />;
};
